import React, { useState } from 'react';
import { users } from '../data/mockData';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotMessage, setForgotMessage] = useState({ type: '', text: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    const user = users.find(
      u => u.username === username && u.password === password
    );

    if (user) {
      onLogin(user);
    } else {
      setError('Identifiant ou mot de passe incorrect');
    }
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    setForgotMessage({ type: '', text: '' });

    if (!forgotEmail.trim()) {
      setForgotMessage({ type: 'error', text: 'Veuillez entrer votre adresse email' });
      return;
    }

    // Vérifier si l'email existe
    const userExists = users.find(u => u.email.toLowerCase() === forgotEmail.toLowerCase());
    
    if (userExists) {
      // Simuler l'envoi d'email
      console.log('Email de réinitialisation envoyé à:', forgotEmail);
      setForgotMessage({ 
        type: 'success', 
        text: 'Un email de réinitialisation a été envoyé à votre adresse email.' 
      });
      setTimeout(() => {
        setShowForgotPassword(false);
        setForgotEmail('');
        setForgotMessage({ type: '', text: '' });
      }, 3000);
    } else {
      setForgotMessage({ 
        type: 'error', 
        text: 'Aucun compte associé à cette adresse email.' 
      });
    }
  };

  // Affichage du formulaire de mot de passe oublié
  if (showForgotPassword) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1>🔐 Mot de passe oublié</h1>
            <p>Entrez votre email pour recevoir un lien de réinitialisation</p>
          </div>
          
          <form onSubmit={handleForgotPassword} className="login-form">
            {forgotMessage.text && (
              <div className={`alert alert-${forgotMessage.type}`}>
                {forgotMessage.text}
              </div>
            )}
            
            <div className="form-group">
              <label htmlFor="forgotEmail">Adresse email</label>
              <input
                type="email"
                id="forgotEmail"
                value={forgotEmail}
                onChange={(e) => setForgotEmail(e.target.value)}
                placeholder="votre.email@brillanty.fr"
                required
                autoFocus
              />
            </div>
            
            <button type="submit" className="btn btn-primary btn-block">
              Envoyer le lien
            </button>

            <button 
              type="button" 
              onClick={() => {
                setShowForgotPassword(false);
                setForgotMessage({ type: '', text: '' });
              }}
              className="btn btn-secondary btn-block"
              style={{ marginTop: '0.5rem' }}
            >
              Retour à la connexion
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>🚗 Brillanty</h1>
          <p>Gestion des interventions de lavage</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="alert alert-error">
              {error}
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="username">Identifiant</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          
          <button type="submit" className="btn btn-primary btn-block">
            Se connecter
          </button>

          <div className="forgot-password-link">
            <button 
              type="button"
              onClick={() => setShowForgotPassword(true)}
              className="btn-link"
            >
              Mot de passe oublié ?
            </button>
          </div>
        </form>
        
        <div className="login-footer">
          <p><strong>Accès rapide :</strong></p>
          <div className="quick-login-buttons">
            <button 
              type="button"
              onClick={() => {
                const admin = users.find(u => u.role === 'admin');
                if (admin) onLogin(admin);
              }}
              className="quick-login-btn admin"
            >
              <span className="quick-login-icon">👔</span>
              <span className="quick-login-label">Administrateur</span>
            </button>
            <button 
              type="button"
              onClick={() => {
                const tech = users.find(u => u.role === 'technicien');
                if (tech) onLogin(tech);
              }}
              className="quick-login-btn tech"
            >
              <span className="quick-login-icon">🔧</span>
              <span className="quick-login-label">Technicien</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;

